import React from "react";
import "./ServerUnavailable.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faServer } from "@fortawesome/free-solid-svg-icons";

const ServerUnavailable = () => {
  return (
    <div className="server-unavailable-container">
      <div className="server-unavailable-content">
        <FontAwesomeIcon icon={faServer} className="server-unavailable-icon" />
        <h1 className="server-unavailable-title">503</h1>
        <h2 className="server-unavailable-subtitle">Server is Unavailable</h2>
        <p className="server-unavailable-text">
          We are experiencing some technical difficulties. Please try again later.
        </p>
      </div>
    </div>
  );
};

export default ServerUnavailable;
